module.exports = __webpack_public_path__ + "static/media/duo-lockup-horizontal-light.22ff30f8.svg";